var map = {
	"./1.svg": 9387,
	"./2.svg": 4719,
	"./3.svg": 3339,
	"./4.svg": 5272,
	"./5.svg": 122,
	"./6.svg": 4873,
	"./7.svg": 3219,
	"./8.svg": 3774,
	"./9.svg": 1815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3407;